import { LeadType, UserNoteType, UserType } from '@repo/validation';

export const leadTypeToUserNoteType = (leadType: LeadType): UserNoteType => {
  switch (leadType) {
    case LeadType.Enrolment:
      return UserNoteType.Enrolment;
    case LeadType.Contact:
      return UserNoteType.Contact;
    default:
      throw new Error(`Unsupported LeadType: ${leadType}`);
  }
};

export const userTypeToUserNoteType = (userType: UserType): UserNoteType => {
  switch (userType) {
    case UserType.Student:
      return UserNoteType.Student;
    case UserType.Staff:
      return UserNoteType.Staff;
    default:
      throw new Error(`Unsupported UserType: ${userType}`);
  }
};
